import { Button, DialogTitle, styled, TableCell } from 'opensolar-ui'

export const BomCell = styled(TableCell)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.grey[200]}`,
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
}))

export const StyledDialogTitle = styled(DialogTitle)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '20px 24px',
})

export const StyledSaveButton = styled(Button)(({ theme }) => ({
  color: `${theme.palette.neutralGrey[100]} !important`,
  backgroundColor: `${theme.palette.blue[800]} !important`,
  '&:hover': {
    backgroundColor: `${theme.palette.blue[800]} !important`,
  },
}))
